<!-- /* [NT-PF-READ-C-POP] 프로필보기(기업) */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      title="프로필 보기"
      v-if="data"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <div class="popupViewProfileCardImage">
          <figure class="networkSearchItemImage">
            <img
              :src="
                !this.lodash.isEmpty(data.avatar)
                  ? data.avatar
                  : '/images/manager/matching/matching1.png'
              "
              alt="미국 국기"
            />
          </figure>
          <div class="popupViewProfileCardImageText">
            <h3 class="popupViewProfileCardImageTitle">
              {{ data.name }}
            </h3>
            <h5 class="popupViewProfileCardImageDesc">
              {{ data.phoneNumber }}
            </h5>
            <h5 class="popupViewProfileCardImageEmail">
              {{ data.email }}
            </h5>
            <MainButton
              btnText="홈페이지"
              customFontSize="16px"
              width="116px"
              customHeight="32px"
              @click="gotoHome(data.homepage)"
              v-if="data.homepage"
            />
          </div>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">기업 정보</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">업종</td>
                <td>
                  <template v-if="data.fieldType">
                    {{
                      this.lodash.find(objFieldType, function(o) {
                        return o.value == data.fieldType;
                      }).text
                    }}
                  </template>
                </td>
              </tr>
              <tr>
                <td class="firstTd">설립 연도</td>
                <td>{{ data.birthday }}</td>
              </tr>
              <tr>
                <td class="firstTd">기업 형태</td>
                <td>
                  <template v-if="data.companyType">
                    {{
                      this.lodash.find(objCompanyType, function(o) {
                        return o.value == data.companyType;
                      }).text
                    }}
                  </template>
                </td>
              </tr>
              <tr>
                <td class="firstTd">사원수</td>
                <td>{{ data.memberSize }}명</td>
              </tr>
              <tr>
                <td class="firstTd">매출 규모</td>
                <td>123억</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">제품(서비스)</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">제품(서비스)명</td>
                <td>기능성 노화예방 힐링크림</td>
              </tr>
              <tr>
                <td class="firstTd">제품(서비스) 설명</td>
                <td>
                  특수 재생물질을 포함한 주름개선 및 피부색 보완을 위한 기능성
                  화장품
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망분야</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">1</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">2</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">3</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">4</td>
                <td class="firstTd">산업</td>
                <td>고령친화의약품 산업</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>정보통신기기, 의약품, 화장품, 식료품, 건강보조식품</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망활동</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">1</td>
                <td class="firstTd">희망 분야</td>
                <td>마케팅</td>
              </tr>
              <tr>
                <td class="firstTd">세부 내용</td>
                <td>홍보하는 방법과 채널을 추천받고 싶습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 12px;">
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">2</td>
                <td class="firstTd">희망 분야</td>
                <td>마케팅</td>
              </tr>
              <tr>
                <td class="firstTd">세부 내용</td>
                <td>홍보하는 방법과 채널을 추천받고 싶습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <template #footer>
        <div style="display: flex; align-items: center; gap: 1rem;">
          <MainButton
            btnText="네트워킹 신청 하기"
            width="191px"
            customHeight="53px"
            fontSize="2rem"
            @click="handleOk(data)"
          />
          <button
            style="border: 1px solid #989898; background-color: #fff; height: 53px; width: 191px;  font-size: 2rem;"
            @click="handleToggleModal"
          >
            닫기
          </button>
        </div>
      </template>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import { fieldType, companyType } from "@/utils/corpUtil";

export default {
  name: "ViewProfileCompany",
  components: { BasicModal, MainButton },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
    handleOk: Function,
    data: Object,
  },
  data() {
    return {
      objFieldType: fieldType,
      objCompanyType: companyType,
    };
  },
  methods: {
    // onClickSubmitForm() { }
    gotoHome(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped></style>
